<template>
  <div class="result" v-if="result">
    <img class="result-image" :src="result.image" :alt="result.title" />
    <div class="result-container">
      <div class="result-text">
        <div>
          <h2 class="result-title" v-html="result.title_html"></h2>
          <p class="main-text" v-html="result.description_html"></p>
        </div>
      </div>
    </div>
    <div class="button-container">
      <button
          class="button-share"
          @click="saveResult"
      >
        {{ serviceTexts.share }}
        <img
            src="@/assets/images/share.svg"
            alt="Save"
            class="button-icon"
        />
      </button>
    </div>
    <canvas ref="canvas" style="display: none;"></canvas>
  </div>
  <p v-else>Loading...</p>
</template>

<script>
import resultsData from "@/assets/results.json";

export default {
  props: ["score", "language", "serviceTexts"],
  data() {
    return {
      result: null,
    };
  },
  computed: {
    results() {
      return resultsData[this.language] || [];
    },
  },
  watch: {
    language() {
      this.calculateResult();
    },
  },
  created() {
    this.calculateResult();
  },
  methods: {
    async calculateResult() {
      let matchedResult = this.results.find(
          (result) =>
              this.score >= result.minScore && this.score <= result.maxScore
      );

      if (matchedResult) {
        const imageModule = await import(`@/assets/images/${matchedResult.imageName}`);
        matchedResult.image = imageModule.default;
      } else {
        const imageModule = await import(`@/assets/images/default.png`);
        matchedResult.image = imageModule.default;
      }

      this.result = matchedResult;
    },
    async saveResult() {
      const canvas = this.$refs.canvas;
      const context = canvas.getContext("2d");

      const canvasWidth = 350;
      const canvasHeight = 600;
      canvas.width = canvasWidth;
      canvas.height = canvasHeight;

      context.fillStyle = "#9FD9B4";
      context.fillRect(0, 0, canvasWidth, canvasHeight);

      const image = new Image();
      image.src = this.result.image;

      image.onload = () => {
        context.drawImage(image, 0, 0, canvasWidth, canvasHeight / 2 + 50);

        const containerX = 20;
        const containerY = canvasHeight / 2 + 20;
        const containerWidth = canvasWidth - 40;
        const containerHeight = 250;
        const borderRadius = 10;

        context.fillStyle = "white";
        context.beginPath();
        context.moveTo(containerX + borderRadius, containerY);
        context.lineTo(containerX + containerWidth - borderRadius, containerY);
        context.quadraticCurveTo(
            containerX + containerWidth,
            containerY,
            containerX + containerWidth,
            containerY + borderRadius
        );
        context.lineTo(containerX + containerWidth, containerY + containerHeight - borderRadius);
        context.quadraticCurveTo(
            containerX + containerWidth,
            containerY + containerHeight,
            containerX + containerWidth - borderRadius,
            containerY + containerHeight
        );
        context.lineTo(containerX + borderRadius, containerY + containerHeight);
        context.quadraticCurveTo(
            containerX,
            containerY + containerHeight,
            containerX,
            containerY + containerHeight - borderRadius
        );
        context.lineTo(containerX, containerY + borderRadius);
        context.quadraticCurveTo(containerX, containerY, containerX + borderRadius, containerY);
        context.closePath();
        context.fill();

        context.fillStyle = "#00008F";
        context.font = "18px Arial";
        context.textAlign = "center";

        const textX = canvasWidth / 2;
        const textY = containerY + 30;
        const lineHeight = 24;
        const maxWidth = containerWidth - 20;

        const wrapText = (text, x, y, maxWidth, lineHeight) => {
          const words = text.split(" ");
          let line = "";
          let yPosition = y;

          for (let n = 0; n < words.length; n++) {
            const testLine = line + words[n] + " ";
            const metrics = context.measureText(testLine);
            const testWidth = metrics.width;

            if (testWidth > maxWidth && n > 0) {
              context.fillText(line, x, yPosition);
              line = words[n] + " ";
              yPosition += lineHeight;
            } else {
              line = testLine;
            }
          }
          context.fillText(line, x, yPosition);
        };

        wrapText(this.result.title, textX, textY, maxWidth, lineHeight);
        wrapText(this.result.description, textX, textY + lineHeight * 2, maxWidth, lineHeight);

        canvas.toBlob((blob) => {
          const file = new File([blob], "result.png", {type: "image/png"});

          if (navigator.canShare && navigator.canShare({files: [file]})) {
            navigator.share({
              files: [file],
              title: "Result",
              text: `${this.result.title}\n${this.result.description}`,
            }).catch((error) => {
              console.error("Error sharing", error);
            });
          } else {
            const link = document.createElement("a");
            link.href = URL.createObjectURL(file);
            link.download = "result.png";
            link.click();
          }
        }, "image/png");
      };
    },
  },
};
</script>
